import type {
  LegacyGetRecordDataDto,
  LegacyGetSearchDataDto,
} from "@docket/consumer-app-client-typescript-axios";

// The generated client types ids as strings; responses are normalized to numeric ids.

export interface LegacyGetSearchesResponseDtoWithIntId {
  data: LegacyGetSearchDataDtoWithIntId[];
}

export interface LegacyGetSearchDataDtoWithIntId extends Omit<LegacyGetSearchDataDto, "id"> {
  id: number;
}

export interface LegacyGetRecordsResponseDtoWithIntId {
  data: LegacyGetRecordDataDtoWithIntId[];
}

export interface LegacyGetRecordDataDtoWithIntId extends Omit<LegacyGetRecordDataDto, "id"> {
  id: number;
}

export enum LegalSex {
  Male = "M",
  Female = "F",
  Unknown = "U",
  Other = "X",
}

/** Searches send the letter, some sign-in responses the whole word ("male"). */
export function legalSexFromString(legalSex: string | null): LegalSex {
  if (!legalSex) {
    return LegalSex.Unknown;
  }

  const upperLegalSex = legalSex.toUpperCase();
  const byLetter = Object.values(LegalSex).find((value: string) => value === upperLegalSex);
  if (byLetter) {
    return byLetter;
  }

  const byWord: Record<string, LegalSex> = {
    MALE: LegalSex.Male,
    FEMALE: LegalSex.Female,
    UNKNOWN: LegalSex.Unknown,
    OTHER: LegalSex.Other,
  };
  const fromWord = Object.entries(byWord).find(([word]) => word === upperLegalSex);
  if (fromWord) {
    return fromWord[1];
  }
  throw new Error(`Could not determine legal sex for string '${legalSex}'`);
}

export enum MatchStatus {
  NoMatch = "NO_MATCH",
  Match = "MATCH",
  BasicMatchNoContacts = "BASIC_MATCH_NO_CONTACTS",
  PartialMatchAltContacts = "PARTIAL_MATCH_ALT_CONTACTS",
  PartialMatchNoContacts = "PARTIAL_MATCH_NO_CONTACTS",
  MultiMatch = "MULTI_MATCH",
  InQueue = "IN_QUEUE",
}

export function matchStatusFromString(matchStatus?: string): MatchStatus {
  return (
    Object.values(MatchStatus).find((value: string) => value === matchStatus) ?? MatchStatus.NoMatch
  );
}

export enum ReportType {
  HISTORY_REPORT = "history_report", // default
  SCHOOL_REPORT = "school_report",
  FORECAST_REPORT = "forecast_report",
  PERSONAL_REPORT = "personal_report",
}

export function reportTypeFromString(reportType: string): ReportType {
  const lower = reportType.toLowerCase();
  const match = Object.values(ReportType).find((value: string) => value === lower);
  if (!match) {
    throw new Error(`Could not find a report type that matches '${reportType}'`);
  }
  return match;
}
